import classes from "~/Wishlist/page/WishlistPage/components/WishlistDetails/components/WishlistItem/WishlistItem.module.less";
import type { SvgIconProps } from "@mui/material";
import { IconButton } from "@mui/material";
import { ToggleCommentIcon } from "~/common/components/icon/ToggleCommentIcon";

interface CommentButtonProps {
  className?: string;
  onClick: () => void;
  open: boolean;
  fontSize?: SvgIconProps["fontSize"];
}

export const CommentButton = ({ className, onClick, open, fontSize }: CommentButtonProps) => (
  <IconButton onClick={onClick} data-test-id={"btn-toggle-comment"} color={"primary"} className={className}>
    <ToggleCommentIcon className={classes.icon} fontSize={fontSize} open={open} />
  </IconButton>
);
